import { QueryWrapper } from '@diamond/shared/data-access';
import { ProductCategory, ProductFilter } from '@diamond/shared/types';
import shallow from 'zustand/shallow';

import { useAuthStore, useShipToStore } from '../stores';

export const useWishlistData = () => {
  const session = useAuthStore();

  const [selectedShipToDc] = useShipToStore(
    (s) => [s.selectedShipToDc],
    shallow
  );

  const queryProductFilter = QueryWrapper(
    '/product/filters',
    session.access_token
  );

  const queryProductCategory = QueryWrapper(
    '/product/category',
    session.access_token
  );

  const { data: productFilter } = queryProductFilter.useQueryGet<ProductFilter>(
    'ProductFilter',
    {
      distribution_channel: selectedShipToDc,
    }
  );

  const { data: productCategory } =
    queryProductCategory.useQueryData<ProductCategory>('ProductCategory');

  const productFilterData = productFilter as ProductFilter;

  const divisionData = productFilterData.divisions?.map((val) => {
    return {
      label: val.name,
      value: val.divisi_code,
    };
  });

  const storagesData = productFilterData.storages?.map((val) => {
    return {
      label: val.name,
      value: val.storage_code,
    };
  });

  const sortsData = productFilterData.sorts?.map((val) => {
    return {
      label: val.name,
      value: val.sort_by_code,
    };
  });

  return {
    divisionData,
    storagesData,
    sortsData,
    productCategory,
  };
};

export default useWishlistData;
